import React, { Fragment, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Otazka from './Otazka';
import Data from './Data/Data.js'
import TestOtazka from './testOtazka'
import { useStore } from '../../utils/score'

export default function Home() {
    const [active, setActive] = useState("Test");
   
    const scoreGold = useStore(state => state.scoreZlato)
    const scoreSilicon = useStore(state => state.scoreKremik) 
    


 
    useEffect(() => {
        localStorage.setItem("eduraw", JSON.stringify([]))
        

    },[]) 


     
    return (
        <Fragment>
        <Helmet><title>Eduraw</title></Helmet>
        <div id="home">
             
            <section className='main-results'>
               
               <div className="header-main">
                
                    <div className="header-gold"> 
                        <div className="gold-avatar">
                            <img className='' src={require('../../img/gold-avatar.png')} alt="alt"/>
                        </div>

                        <div className='gold-points'>
                            <h4 className="score-gold">Gold: {scoreGold}</h4>
                        </div>
                    </div>

                    <div className="header-logo"> 
                        <img className='play-logo' src={require('../../img/logo-trans.png')} alt="alt"/>
                    </div>

                    <div className="header-silicon"> 
                        

                        <div className='silicon-points'>
                            <h4 className="score-silicon">Silicon: {scoreSilicon}</h4>
                        </div>

                        <div className="silicon-avatar">
                        <img className='' src={require('../../img/silicon-avatar.png')} alt="alt"/>
                        </div>
                        
                    </div>

                </div>
              
                <div className="quiz-container">
                   
                   <div className='quiz-gold'>
                        <div className="otazky-gold" onClick={() => setActive("Dejepis")}>
                            <h5>History</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Geografia")}>
                            <h5 >Geography</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Biologia")}>
                            <h5 >Biology</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Astronomia")}>
                            <h5>Astronomy</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Chemia")}>
                            <h5>Chemistry</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Sport")}>
                            <h5>Sport</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Architektura")}>
                            <h5>Architecture</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Geologia")}>
                            <h5>Geology</h5>
                        </div>
                        <div className="otazky-gold" onClick={() => setActive("Elektronika")}>
                            <h5>Electronics</h5>
                        </div>
                   </div>

                   <div className='quiz-question'>
                        
                        {active === "Test" && <TestOtazka data={Data} cardIndex={0}/> }

                        {active === "Dejepis" && <TestOtazka data={Data} cardIndex={0} />}
                        {active === "Geografia" && <Otazka data={Data} cardIndex={1} />}
                        {active === "Biologia" && <Otazka data={Data} cardIndex={2} />}
                        {active === "Astronomia" && <Otazka data={Data} cardIndex={3} />}
                        {active === "Chemia" && <Otazka data={Data} cardIndex={4} />}
                        {active === "Sport" && <Otazka data={Data} cardIndex={5} />}
                        {active === "Architektura" && <Otazka data={Data} cardIndex={6} />}
                        {active === "Geologia" && <Otazka data={Data} cardIndex={7} />}
                        {active === "Elektronika" && <Otazka data={Data} cardIndex={8} />}
                        
                        {active === "Fyzika" && <Otazka data={Data} cardIndex={9} />}
                        {active === "Chemia-sil" && <Otazka data={Data} cardIndex={10} />}
                        {active === "Gastronomia" && <Otazka data={Data} cardIndex={11} />}
                        {active === "Agrikultura" && <Otazka data={Data} cardIndex={12} />}
                        {active === "Astronomia-sil" && <Otazka data={Data} cardIndex={13} />}
                        {active === "Hodinky" && <Otazka data={Data} cardIndex={14} />}
                        {active === "Osobnosti" && <Otazka data={Data} cardIndex={15} />}
                        {active === "Pocitace" && <Otazka data={Data} cardIndex={16} />}
                        {active === "Mechanika" && <Otazka data={Data} cardIndex={17} />}
                        

                   </div>

                   <div className='quiz-silicon'>
                   <div className="otazky-silicon" onClick={() => setActive("Fyzika")}>
                            <h5>Physics</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Chemia-sil")}>
                            <h5>Chemistry</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Gastronomia")}>
                            <h5>Gastronomy</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Agrikultura")}>
                            <h5>Agriculture</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Astronomia-sil")}>
                            <h5>Astronomy</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Hodinky")}>
                            <h5>Watches</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Osobnosti")}> 
                            <h5>Personalities</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Pocitace")}>
                            <h5>Computers</h5>
                        </div>
                        <div className="otazky-silicon" onClick={() => setActive("Mechanika")}>
                            <h5>Engineering</h5>
                        </div>
                        
                   </div>
                   
                </div>

                
            </section> 

            
        </div>   
      

    </Fragment>

    )
}

